import React from 'react'

function Separator({ className }) {
    return <div className={className || 'separador'} />
}

export default Separator
